// @ts-nocheck
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var dbDateHelperMMDD = function (dateStr) {
    var date = new Date(dateStr);
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var dbDateHelper = function (dateStr) {
    if (dateStr) {
        var date = new Date(dateStr);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
    }
    return "N/A";
};
var dbDateHelperWithHHMM = function (dateStr) {
    var date = new Date(dateStr);
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes);
};
var splitDateTimeHelper = function (dateStr) {
    //original dateStr: "7/16/2024, 4:55:23 PM"
    var dateParts = dateStr.split(",");
    var formattedDate = dateParts[0];
    return formattedDate;
};
var blueIDHelper = function (idStr) {
    if (idStr) {
        var asterisks = "*".repeat(Math.min(4, idStr.length));
        var modifiedString = asterisks + idStr.substring(4);
        return modifiedString;
    }
    return idStr;
};
var subjectIdHelper = function (idStr) {
    if (idStr) {
        var modifiedString = "...." + idStr.slice(-4);
        return modifiedString;
    }
    return idStr;
};
var pdfSubjectIdHelper = function (idStr) {
    if (idStr) {
        var modifiedString = idStr.slice(-4);
        return modifiedString;
    }
    return idStr;
};
var longNameHelper = function (longStr) {
    if (longStr && (longStr === null || longStr === void 0 ? void 0 : longStr.length) > 26) {
        var modifiedString = "...." + longStr.slice(-4);
        return modifiedString;
    }
    return longStr;
};
var imgSrcPathHelper = function (src) {
    if (src) {
        var modifiedString = src.replace(/\\/g, "/");
        return modifiedString;
    }
    return src;
};
var dragImgNameHelper = function (str) {
    if (str && (str === null || str === void 0 ? void 0 : str.length) > 24) {
        return "..." + str.slice(-21);
    }
    return str;
    // return "dragImgNameHelperdragImgNameHelperdragImgNameHelper".slice(-21)
};
var emptyFunc = function () {
};
var secToMin = function (secondsStr) {
    var minutes = Math.floor(secondsStr / 60);
    var seconds = secondsStr % 60;
    var timeString = "".concat(minutes, " min \n    ").concat(seconds > 0 ? seconds + " sec" : "", " ");
    return timeString;
};
//flatten nested obj with _ (e.g. image: {x: 1} -> image_x: 1)
var flattenObjectWithUnderscores = function (obj, parentKey) {
    if (parentKey === void 0) { parentKey = ''; }
    var result = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            var newKey = parentKey ? "".concat(parentKey, "_").concat(key) : key;
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                Object.assign(result, flattenObjectWithUnderscores(obj[key], newKey));
            }
            else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
};
//exclude (delete) array of key from object
var excludeFromObj = function (obj, excludeArr) {
    var newObj = __assign({}, obj);
    excludeArr.forEach(function (key) {
        if (newObj.hasOwnProperty(key)) {
            delete newObj[key];
        }
    });
    return newObj;
};
// update exam panel's dates (no repeat, newest to oldest)
var updateNewExamDates = function (examDates) {
    var prevExamDates = __spreadArray([], examDates, true);
    var newPrevExamDates = new Set(prevExamDates.map(function (item) {
        var date = new Date(item.exam_date);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
    }));
    var newUniqExamDatesArray = Array.from(newPrevExamDates).map(function (date) { return ({ exam_date: date }); });
    prevExamDates = newUniqExamDatesArray.sort(function (a, b) { return new Date(b.exam_date) - new Date(a.exam_date); });
    return prevExamDates;
};
export { dbDateHelper, dbDateHelperWithHHMM, blueIDHelper, imgSrcPathHelper, splitDateTimeHelper, subjectIdHelper, emptyFunc, secToMin, dragImgNameHelper, flattenObjectWithUnderscores, excludeFromObj, longNameHelper, pdfSubjectIdHelper, dbDateHelperMMDD, updateNewExamDates, };
